import React, { useEffect, useState } from 'react'
import { useSymbolPrices } from '../../../context/WebSocketContext';
import { useDispatch, useSelector } from 'react-redux';
import { updateProfitLoss } from '../../../store/Slices/profitLossSlice';
import { SetPLValue } from '../../footer/AccountFooter';

const ProfitLoss = ({ row }) => {
    const symbols = useSymbolPrices();
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const dispatch = useDispatch()
    const [floatingPL, setFloatingPL] = useState(0);
    // allSymbolParams?.[symbol]
    const calculateProfitForRow = () => {
        const symbolData = allSymbolParams?.[row.symbolId]
        const symbol = symbols[row.symbolId]

        if (!row) return 0;
        if (!symbol) return 0;
        if (!symbolData) return 0; 
        const { amount, side, openPrice, interest, closeCommissionValue } = row;
        const { closeCommissionType } = symbolData;
        const { bid, ask } = symbol

        let currentPrice = side === 1 ? bid : ask;
        let profitLoss;

        const calculateCloseCommission = () => {
            if (closeCommissionType == 0) {
                return 0
            } else if (closeCommissionType == 1) {
                return amount * symbol.contractSize * currentPrice * 0.01 * closeCommissionValue * (calculateRefValue() || 1)
            } else if (closeCommissionType == 2) {
                return closeCommissionValue * amount;
            } else if (closeCommissionType == 3) {
                return closeCommission
            } else {
                return 0;
            }
        }

        const calculateRefValue = () => {

            if (!symbolData) return 1; // Default value if symbolData is missing

            const { referenceSymbolCalculationType } = symbolData;

            // **Check if reference symbol is USD**
            if (symbol?.referenceSymbolId == null || symbol.referenceSymbolId == 0 || symbols?.[symbol?.referenceSymbolId] == null) {
                return 1; // USD reference value is always 1
            }

            // **Apply reference symbol calculation type**
            return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
        };

        const closeCommission = calculateCloseCommission() || 0

        if (symbol?.referenceSymbolId == null || symbol.referenceSymbolId == 0 || symbols?.[symbol?.referenceSymbolId] == null) {
            if (side == 1) {
                profitLoss = (currentPrice - openPrice) * symbol.contractSize * amount - closeCommission + interest;
            } else {
                profitLoss = ((openPrice - currentPrice) * symbol.contractSize * amount) - closeCommission + interest
            }
        } else {
            const refSymbol = symbols?.[symbol?.referenceSymbolId]
            if (side == 1) {
                if (symbol?.referenceSymbolCalculationType == 1) {
                    profitLoss = (((currentPrice - openPrice) * refSymbol.bid) * symbol.contractSize * amount) - closeCommission + interest
                } else {
                    profitLoss = (((currentPrice - openPrice) / refSymbol.bid) * symbol.contractSize * amount) - closeCommission + interest
                }
            } else {
                if (symbol.referenceSymbolCalculationType == 1) {
                    profitLoss = (((openPrice - currentPrice) * refSymbol.bid) * symbol.contractSize * amount) - closeCommission + interest
                } else {
                    profitLoss = (((openPrice - currentPrice) / refSymbol.bid) * symbol.contractSize * amount) - closeCommission + interest
                }
            } 
        }

        const formattedProfitLoss = parseFloat(profitLoss)?.toFixed(2);
        dispatch(updateProfitLoss());
        SetPLValue(row.id,formattedProfitLoss)
        return formattedProfitLoss
    };
    useEffect(() => {
        const updatedPL = calculateProfitForRow();
        setFloatingPL(updatedPL);
    }, [symbols[row.symbolId]])

    return (
        <span className={`${floatingPL < 0 ? "red" : "green"}`} >{floatingPL}</span>
    )
}

export default ProfitLoss
